// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WT4wA","icon":"styles_icon__3k-Nj"};